import './App.css';
import {BrowserRouter,Route,Routes} from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Home } from './home/home';
import { Create } from './home/create';
import { LandingPage } from './home';
import { Signup } from './Components/signup';
import { Update } from './home/update';
import { Forgot } from './home/forgot';
import Templet1 from './templates/templet1/Templet1';
import { useState } from 'react';
import { ToastContainer } from 'react-toastify';



function App() {
  const [theme,setTheme]=useState("dark")
  const [profileData,setProfileData] = useState()
  return (
    <>
    <div>
    <BrowserRouter>
    <Routes>
      <Route path='/' element={<LandingPage />}/>
      <Route path='/signup' element={<Signup/>}/>
      <Route path='/:name' element={theme==="dark"?<Home setTheme={setTheme} setProfileData={setProfileData} profileData={profileData}/>:<Templet1 profileData={profileData} setTheme={setTheme}  />}/>
      <Route path='/create' element={<Create/>}/>
      <Route path='/update' element={<Update />}/>
      <Route path='/forgot' element={<Forgot />}/>
      {/* <Route path='/templet1/:name' element={<Templet1 />}/> */}

      
    </Routes>
    </BrowserRouter>
    <ToastContainer
        position="top-right" 
        autoClose={5000} 
        hideProgressBar={false} 
        newestOnTop={false} 
        closeOnClick 
        rtl={false} 
        pauseOnFocusLoss 
        draggable 
        pauseOnHover
        theme='colored'
      />
    </div>
    
    </>
  );
}
export default App;
